import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=1c5d83b0&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=1c5d83b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d83b0",
  null
  
)

export default component.exports